import { html, render } from 'lit-html';

document.addEventListener("DOMContentLoaded", () => {
    const gqlToken = window.gqlToken;
    var gqlKey = window.gqlKey;
    // console.clear();
    var work = document.querySelector("#workOuterShell");
    if(work){
        var loadMore = document.getElementById("loadMoreIndustries");

        loadMore.addEventListener("click", function() {
            var hiddenGridItems = document.querySelectorAll('.grid-wrap--hidden')
            if (hiddenGridItems) {
                // container.classList.add('pre-animation');
                setTimeout(function() {
                    hiddenGridItems.forEach(function (item, index) {
                        if (index < 12) {
                            item.classList.remove('grid-wrap--hidden');
                        }
                    })
                    if (document.querySelectorAll('.grid-wrap--hidden').length === 0) {
                        loadMore.closest('#loadMoreIndustriesContainer').classList.add('hidden');
                    }
                }, 500)
            }
        });
    }


    const categoryTriggers = document.querySelectorAll('.category');
    const container = document.getElementById('workOuterShell');
    const allCategory = document.getElementById('all-category-filter');

    if(categoryTriggers.length){
        for (var i = 0; i < categoryTriggers.length; i++) {
            categoryTriggers[i].addEventListener('click',  function(e) {
                    e.stopPropagation()
                    container.classList.add('pre-animation');
                    var industryName = this.getAttribute('data-industry');
                    console.log(industryName);
                    if(industryName){
                        fetch('/industry?'+industryName,{
                            method: 'get',
                            headers: new Headers({
                                'Authorization': 'Bearer '+gqlToken,
                                'Xauthkey': gqlKey,
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }),
                        }).then(function (response) {
                            console.log('success!', response);
                            // The API call was successful!
                            return response.json();
                        }).then(function (data) {
                            // This is the JSON from our response
                            console.log(data);
                            if(data.length){
                                var itemsCount = 0;
                                const rows = data.map(data => {
                                    if (data.slug != null || data.slug != undefined) {
                                        itemsCount = itemsCount+1;
                                        var bannerUrl = 'https://place-hold.it/480x480';
                                        if(data.image[0]){
                                            var bannerUrl =  data.image[0].url;
                                        }else{console.log(" No Banner ");}
                                        return `
                                        ${itemsCount > 12  ? ' <div class="grid-wrap grid-wrap--hidden filter-results">' : ' <div class="grid-wrap filter-results">'}
                                        <div class="grid-item item">
                                            <a href="javascript:;" onclick="getInustryInfo(this)" class="tile open-popup" data-industry="${data.slug}"  ${data.popupDescription != null ? `data-micromodal-trigger="modal-${data.slug}"` : "" }>
                                                <img src="${bannerUrl}" width="540" height="510" alt="${data.title}" />
                                                <div class="overlay overlay--reverse"></div>
                                                <div class="absolute bottom-0 left-0 right-0 px-8">
                                                    <h6 class="tile-title overlay-title-bump mb-6">${data.title}</h6>
                                                </div>
                                                <div class="border-hover absolute inset-0"></div>
                                            </a>
                                            </div>
                                        </div>
                                        `;
                                    }else{
                                        console.log("empty");
                                    }
                                });
                                // console.log('itemsCount!', itemsCount);
                                if(itemsCount > 12){
                                    loadMore.style.display = "";
                                }else{
                                    loadMore.style.display = "none";
                                }
                                const html = `${rows.join('')}`;
                                setTimeout(function(){
                                    container.innerHTML = html;
                                    container.classList.remove('pre-animation')
                                }, 500);
                            }else{
                                setTimeout(function(){
                                    container.innerHTML = `<div class="col-start-1 col-end-4"><p class="h6 text-white text-center">Sorry, no results were found</p></div>`;
                                    container.classList.remove('pre-animation')
                                }, 500)
                            }
                        })
                        .catch(function (err) {
                            // There was an error
                            setTimeout(function(){
                                container.innerHTML = `<div class="col-start-1 col-end-4"><p class="h6 text-white text-center">Sorry, no results were found</p></div>`;
                                container.classList.remove('pre-animation')
                            },500)
                            console.warn('Something went wrong.', err);
                        });
                    }
            });
        }
    }

    function bindEvent(el, eventName, eventHandler) {
        if (el.addEventListener){
            el.addEventListener(eventName, eventHandler, false);
        } else if (el.attachEvent){
            el.attachEvent('on'+eventName, eventHandler);
        }
    }

});